import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getWaitingListTimesShopName } from '../waitingList/selectors';
import { getShopName } from '../shops/selectors';
import * as reservationSelectors from '../reservation/selectors';

const mapStateToProps = (state, ownProps) => ({
  shopName:
    getShopName(state, ownProps.params.shopRoute) ||
    reservationSelectors.getShopName(state) ||
    getWaitingListTimesShopName(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithShopName.js